import { ChangeEvent } from "react";
import GenericTable from "@/shared/components/table/GenericTable";
import { AdminLeadListResDto } from "service/api/estabrookSchemas";
import { FilterState, UpdateFilter } from "../hooks/useLeadsFilters";
import useLeadsTableHeader from "../hooks/useLeadsTableHeader";
import useLeadsTableRow from "../hooks/useLeadsTableRow";

interface LeadsTableProps {
  data?: AdminLeadListResDto[];
  isLoading?: boolean;
  filters: FilterState;
  updateFilter: UpdateFilter;
  handleLeadSelection: (
    evt: ChangeEvent<HTMLInputElement>,
    leadId: string,
  ) => void;
  handleLeadSelectionAll: (evt: ChangeEvent<HTMLInputElement>) => void;
}

const LeadsTable = ({
  data = [],
  isLoading,
  filters,
  updateFilter,
  handleLeadSelection,
  handleLeadSelectionAll,
}: LeadsTableProps) => {
  const headers = useLeadsTableHeader(filters, data, handleLeadSelectionAll);
  const renderRowLabel = useLeadsTableRow(filters, handleLeadSelection);

  return (
    <GenericTable
      sx={{ mt: "20px" }}
      headers={headers}
      renderRowLabel={renderRowLabel}
      data={data}
      sortOptions={filters.sortOptions}
      onSortChange={(sortOptions) => updateFilter("sortOptions", sortOptions)}
      isLoading={isLoading}
    />
  );
};

export default LeadsTable;
